// extracted by mini-css-extract-plugin
export default {"wrapper":"ChatRoomTopBar-module-ea1dbb68b927413f58d3","avatar":"ChatRoomTopBar-module-eedf1659430bcd88a425","inviteTop":"ChatRoomTopBar-module-bffffb15759d2a3c583b"};